import React from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dispatchAuthenticationFactorsRefresh } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import {
  FDBodyText, FDDialogActions, FDDialogContent, FDDialogTitle, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import ErrorList from 'Components/UI/ErrorList';

const EnterVerificationCode = ({ onSuccess }) => {
  const { onSubmit, errors } = useMetaLayoutContext();
  const { displaySuccess } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleSubmit = async () => {
    const resp = await onSubmit();

    // resp will only be set if submission is successful (see useMetaFormBuilder handleSubmit for details)
    if (resp) {
      displaySuccess('Authenticator app enabled');
      logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Submit verification code');
      dispatchAuthenticationFactorsRefresh();
      onSuccess();
    }
  };

  return (
    <>
      <FDDialogTitle size={'lg'} value={'Verify Code'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={2}>
          <FDBodyText
            value={'Enter the one-time six digit code provided by your authentication app.'}
          />
          <MetaControlField attr={'code'} fullWidth />
          <ErrorList title={'Errors occurred while submitting'} errors={errors} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Continue'}
          onClick={handleSubmit}
          test={'security-settings-button-authenticatorApp-register-modal-submit-code'}
        />
      </FDDialogActions>
    </>
  );
};

EnterVerificationCode.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default EnterVerificationCode;
